async function init(){
    if(document.querySelector("#mainContent .accordionHeader")){
        const {default: AccordionClass} = await import("../../common/accordions25.js");
        if (!AccordionClass) return;
        const sourceAccordions = new AccordionClass();
        sourceAccordions.init(document.getElementById("mainContent"));
    }

    if(document.querySelector(".item")){
        const {default: ebook} = await import("./modules/ebook.js");
        if(!ebook) return;
        ebook.init();
    }
}

init();